import { render, staticRenderFns } from "./ShowImage.vue?vue&type=template&id=333f69a4"
import script from "./ShowImage.vue?vue&type=script&lang=js"
export * from "./ShowImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports